<div style="float: left; text-align: center; display: grid; width: 190px; left: 40%; position: relative;">
  <canvas baseChart
          [data]="doughnutChartData"
          [type]="doughnutChartType"
          [options]="doughnutChartOptions"
          [legend]="false"></canvas>

  <div style="left: 0;top: 0;text-align: center;">
    <div style="top: 260%;-webkit-transform: translateY(-260%);-ms-transform: translateY(-260%);transform: translateY(-260%);text-transform: uppercase;font-size: 10px;color: #808080;">
      <div style="  font-size: 28px;line-height: 30px;">
        <strong>{{totaltimecards}}</strong>
      </div>
      Timecards
    </div>
  </div>
</div>
